__turbopack_context__.v({
  "author": "Chat-module__ejmJuW__author",
  "avatar": "Chat-module__ejmJuW__avatar",
  "body": "Chat-module__ejmJuW__body",
  "channel": "Chat-module__ejmJuW__channel",
  "expand-in": "Chat-module__ejmJuW__expand-in",
  "fade-in": "Chat-module__ejmJuW__fade-in",
  "header": "Chat-module__ejmJuW__header",
  "list": "Chat-module__ejmJuW__list",
  "loadButton": "Chat-module__ejmJuW__loadButton",
  "loadRow": "Chat-module__ejmJuW__loadRow",
  "message": "Chat-module__ejmJuW__message",
  "meta": "Chat-module__ejmJuW__meta",
  "resetButton": "Chat-module__ejmJuW__resetButton",
  "root": "Chat-module__ejmJuW__root",
  "scroller": "Chat-module__ejmJuW__scroller",
  "subtitle": "Chat-module__ejmJuW__subtitle",
  "text": "Chat-module__ejmJuW__text",
  "thread": "Chat-module__ejmJuW__thread",
  "threadStart": "Chat-module__ejmJuW__threadStart",
  "time": "Chat-module__ejmJuW__time",
});
